import {
  GenerateClauseListPayload,
  GenerateClauseListResponse,
  GenerateDocumentResponse,
} from '../services/document-generation-api.service';

export interface DocumentGenerationState {
  generatingClauseList: boolean;
  generateClauseListFailed: boolean;
  lastGenerateClauseListPayload: GenerateClauseListPayload | null;
  generateClauseListResponse: GenerateClauseListResponse | null;
  generatingDocument: boolean;
  generateDocumentResponse: GenerateDocumentResponse | null;
  askingGenerateDocumentStatus: boolean;
  closeGenerateDocumentModal: boolean;
  creatingDocumentOperationsAreInProgress: boolean;
}

export const initialState: DocumentGenerationState = {
  generatingClauseList: false,
  generateClauseListFailed: false,
  lastGenerateClauseListPayload: null,
  generateClauseListResponse: null,
  generatingDocument: false,
  generateDocumentResponse: null,
  askingGenerateDocumentStatus: false,
  closeGenerateDocumentModal: false,
  creatingDocumentOperationsAreInProgress: false,
};
